/**
 * Conversão de coordenadas — UTM 23S SIRGAS2000 (EPSG:31983) ↔ WGS84.
 * Domínio puro (proj4 é lib sem React/Supabase/DOM). Regra inviolável #9:
 * usar proj4js, NÃO a fórmula linear do protótipo.
 */
import proj4 from 'proj4';

/** SIRGAS2000 / UTM zona 23S — datum oficial da instrumentação da UPM. */
const EPSG_31983 = '+proj=utm +zone=23 +south +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs';

/**
 * Converte easting/northing (UTM 23S SIRGAS2000) para `[lat, lon]` em WGS84.
 * proj4 trabalha em `[x=lon, y=lat]`; invertemos para o padrão Leaflet `[lat, lon]`.
 */
export function utmToWgs84(easting: number, northing: number): [number, number] {
  const [lon, lat] = proj4(EPSG_31983, 'WGS84', [easting, northing]);
  return [lat, lon];
}

/**
 * Converte `[lat, lon]` (WGS84) para `[easting, northing]` em UTM 23S SIRGAS2000.
 * Inverso de {@link utmToWgs84}, para o map picker do MPA (GUPM-193): o clique no
 * mapa vem em WGS84 e é persistido em UTM 23S (datum da instrumentação).
 *
 * proj4 trabalha em `[x=lon, y=lat]` → devolvemos `[easting, northing]`.
 */
export function wgs84ToUtm(lat: number, lon: number): [number, number] {
  const [easting, northing] = proj4('WGS84', EPSG_31983, [lon, lat]);
  return [easting, northing];
}
